import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useLocationReporter() {
  const [status, setStatus] = useState(navigator.geolocation ? "pending" : "unsupported");
  useEffect(() => {
    if (!navigator.geolocation) return;
    let last = 0;
    const send = (pos) => {
      setStatus("on");
      if (Date.now() - last < 60000) return;
      last = Date.now();
      const { latitude: lat, longitude: lng, accuracy } = pos.coords;
      api.post("/me/location", { lat, lng, accuracy }).catch(() => {});
    };
    const fail = (e) => setStatus(e.code === 1 ? "denied" : "error");
    const opts = { enableHighAccuracy: true, maximumAge: 30000 };
    const id = navigator.geolocation.watchPosition(send, fail, opts);
    const beat = setInterval(() => navigator.geolocation.getCurrentPosition(send, fail, opts), 60000);
    return () => {
      navigator.geolocation.clearWatch(id);
      clearInterval(beat);
    };
  }, []);
  return status;
}
